import React from "react";

const StepCredit = ({ credits, estimated }) => {
  return (
    <div className="space-y-1 text-lg">
      <p>현재 크레딧: <strong className="text-blue-700">{credits}</strong></p>
      <p>예상 소모: <strong className="text-red-600">{estimated}</strong></p>
      <p>작업 후 잔여: <strong className="text-green-600">{credits - estimated}</strong></p>
    </div>
  );
};

export default StepCredit; 